export default __webpack_public_path__ + "static/media/background-people.d3964dbc.svg";